var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._l((_vm.objectIds),function(id,index){return _c('object-icon',{key:index,attrs:{"objectId":id,"invalidObjectIcon":_vm.$icons.mdiSelect}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }